import { AccreditedStatus } from '@arrived/models';

export const getAccreditedStatus = (accreditedInvestor?: boolean): AccreditedStatus => {
  if (typeof accreditedInvestor === 'undefined') {
    return AccreditedStatus.PENDING;
  }

  return accreditedInvestor ? AccreditedStatus.SELF_ACCREDITED : AccreditedStatus.NOT_ACCREDITED;
};
